type DocumentStatusBadgeVariant =
  "danger" | "info" | "primary" | "success" | "warning";

type DocumentStatusBadgeProps = {
  children: string;
  variant: DocumentStatusBadgeVariant;
};

const DocumentStatusBadge = ({
  children,
  variant,
}: DocumentStatusBadgeProps) => {
  return (
    <span
      className={`cle-course-certificate-document__badge cle-course-certificate-document__badge--${variant}`}
    >
      {children}
    </span>
  );
};

export default DocumentStatusBadge;
